/// <amd-module name="VSSUI/DeprecatedAccordion" />
export * from "./Components/DeprecatedAccordion/index";
